import axios from 'axios';

const API_KEY = process.env.REACT_APP_TMDB_API_KEY || 'demo';
const BASE_URL = 'https://api.themoviedb.org/3';
export const IMG_BASE = 'https://image.tmdb.org/t/p';

const tmdb = axios.create({
  baseURL: BASE_URL,
  params: { api_key: API_KEY, language: 'en-US' },
});

export const fetchTrending = () => tmdb.get('/trending/movie/week');
export const fetchTopRated = () => tmdb.get('/movie/top_rated');
export const fetchNowPlaying = () => tmdb.get('/movie/now_playing');
export const fetchPopular = () => tmdb.get('/movie/popular');
export const fetchByGenre = (genreId) => tmdb.get('/discover/movie', { params: { with_genres: genreId, sort_by: 'popularity.desc' } });
export const fetchMovieDetails = (id) => tmdb.get('/movie/' + id, { params: { append_to_response: 'videos,credits,similar,images' } });
export const searchMovies = (query, page = 1) => tmdb.get('/search/movie', { params: { query, page } });
export const fetchGenres = () => tmdb.get('/genre/movie/list');

export const GENRES = {
  ACTION: 28,
  COMEDY: 35,
  DRAMA: 18,
  HORROR: 27,
  SCIFI: 878,
  THRILLER: 53,
  ROMANCE: 10749,
  ANIMATION: 16,
};

export default tmdb;
